import {Shift} from '@app/core/models/shift.model';
import {Message} from '@app/core/models/message.model';
import {Conversation} from '@app/core/models/conversation.model';
import {BulletinBoardPost} from '@app/core/models/bulletinBoardPost.model';
import {SickMessage} from '@app/core/models/sickMessage.model';
import {HttpService} from '@app/core/services/http.service';
import {RDate} from '@app/core/models/rDate.model';
import {Availability} from '@app/core/models/availability.model';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import {BulletinBoardPostComment} from '@app/core/models/bulletinBoardPostComment.model';
import {ENOTIFICATIONTYPE} from '@app/core/enums';
import {EQORebrandIcon} from '@quickorder/angular-web-lib';

export class DatabaseNotification extends BaseModel {
	public id: string;
	public type: ENOTIFICATIONTYPE;
	public shift: Shift;
	public message: Message;
	public conversation: Conversation;
	public message_board_post_comment: BulletinBoardPostComment;
	public message_board_post: BulletinBoardPost;
	public sick_message: SickMessage;
	public availability: Availability;
	public created_at: RDate;
	public updated_at: RDate;
	public read_at: RDate;

	constructor(public httpService: HttpService, tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public read(): boolean {
		return (this.read_at !== null);
	}

	public readableText(translate: TranslateService): string {
		let text = '';
		let data = {};
		let slicedMessage, dates;
		switch (+this.type) {
			case 1:
				const to = translate.instant('NAVBAR.TO');
				text += this.message.user.getFullName();
				const isNotPersonal = !this.conversation.is_personal_conversation;
				if (isNotPersonal) {
					text += (to + ' ' + this.conversation.conversation_name);
				}
				text += ': ';
				slicedMessage = this.message.content.slice(0, 40);
				text += slicedMessage;
				if (slicedMessage !== this.message.content) {
					text += '...';
				}
				break;
			case 2:
				text += this.message_board_post.user.getFullName() + ': ';
				slicedMessage = this.message_board_post.content.slice(0, 40);
				text += slicedMessage;
				if (slicedMessage !== this.message_board_post.content) {
					text += '...';
				}
				break;
			case 3:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.3', data);
				break;
			case 4:
				text = translate.instant('NAVBAR.4');
				break;
			case 5:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.5', data);
				break;
			case 6:
				text = translate.instant('NAVBAR.6');
				break;
			case 7:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.7', data);
				break;
			case 8:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.8', data);
				break;
			case 9:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.9', data);
				break;
			case 10:
				text = translate.instant('NAVBAR.10');
				break;
			case 11:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.11', data);
				break;
			case 12:
				text = translate.instant('NAVBAR.12');
				break;
			case 13:
				dates = this.availability.start.format('date-diff', this.availability.end, false, true);
				data = {dates};
				text = translate.instant('NAVBAR.13', data);
				break;
			case 14:
				dates = this.availability.start.format('date-diff', this.availability.end, false, true);
				data = {dates};
				text = translate.instant('NAVBAR.14', data);
				break;
			case 15:
				data = {date: this.shift.start.format('short-daterange', this.shift.end)};
				text = translate.instant('NAVBAR.15', data);
				break;
			case 16:
				data = {name: this.message_board_post_comment.user.getFullName()};
				text = translate.instant('NAVBAR.16', data);
				break;
			default:
				text += 'Ukendt notifikation';
				break;
		}

		return text;
	}

	public click(router: Router): any {
		let url, params;
		switch (+this.type) {
			case 1:
				url = '/home/beskeder';
				params = {conversationId: this.conversation.id};
				break;
			case 2:
				url = '/home/opslagstavlen';
				params = {messageBoardId: this.message_board_post.id};
				break;
			case 3:
				url = '/home/vagtplan';
				params = {
					date: this.shift.start.localDate.toDate(),
					shiftId: this.shift.id
				};
				break;
			case 4:
				url = '/home/vagtplan';
				params = {};
				break;
			case 5:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 6:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 7:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 8:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 9:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 10:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 11:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 12:
				url = '/home/vagtplan';
				params = {date: this.shift.start.localDate.toDate(), shiftId: this.shift.id};
				break;
			case 13:
				url = '/home/tilgængelighed';
				params = {};
				break;
			case 14:
				url = '/home/tilgængelighed';
				params = {};
				break;
			case 15:
				url = '/home/vagtplan';
				params = {};
				break;
			case 16:
				url = '/home/opslagstavlen';
				params = {messageBoardId: this.message_board_post.id};
				break;
		}
		router.navigate([url], {queryParams: params});
	}

	public getIcon(): EQORebrandIcon {
		switch (+this.type) {
			case ENOTIFICATIONTYPE.TYPE_NEW_MESSAGE: {
				return EQORebrandIcon.chat_dark;
			}

			case ENOTIFICATIONTYPE.TYPE_NEW_MESSAGE_BOARD_POST_COMMENT:
			case ENOTIFICATIONTYPE.TYPE_NEW_MESSAGE_BOARD_POST: {
				return EQORebrandIcon.post_dark;
			}
			case ENOTIFICATIONTYPE.TYPE_NEW_SICK_MESSAGE:
			case ENOTIFICATIONTYPE.TYPE_SICK_MESSAGE_ANOTHER_USER_WAS_SELECTED:
			case ENOTIFICATIONTYPE.TYPE_SICK_MESSAGE_REPLACE_FOR_YOUR_SHIFT_FOUND:
			case ENOTIFICATIONTYPE.TYPE_SICK_MESSAGE_RESPONSE_APPROVED: {
				return EQORebrandIcon.sick_dark;
			}
			case ENOTIFICATIONTYPE.TYPE_NEW_SHIFT:
			case ENOTIFICATIONTYPE.TYPE_DELETED_SHIFT:
			case ENOTIFICATIONTYPE.TYPE_EDITED_SHIFT:
			case ENOTIFICATIONTYPE.TYPE_REPLACEMENT_FOR_YOUR_SHIFT:
			case ENOTIFICATIONTYPE.TYPE_SHIFT_STOCK_BID_APPROVED:
			case ENOTIFICATIONTYPE.TYPE_SHIFT_STOCK_BID_REJECTED:

			case ENOTIFICATIONTYPE.TYPE_AVAILABILITY_APPROVED:
			case ENOTIFICATIONTYPE.TYPE_AVAILABILITY_REJECTED:
			case ENOTIFICATIONTYPE.TYPE_SHIFT_STOCK_CHANGE_APPROVED: {
				return EQORebrandIcon.calendar_dark;
			}

			default: {
				return EQORebrandIcon.notifications_dark;
			}

		}
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.shift) {
			this.shift = new Shift(this.tenantTZ, this.interService).deserialize(input.shift);
		}
		if (input.message) {
			this.message = new Message(this.tenantTZ, this.interService).deserialize(input.message);
		}
		if (input.conversation) {
			this.conversation = new Conversation(this.tenantTZ, this.interService).deserialize(input.conversation);
		}
		if (input.message_board_post) {
			this.message_board_post = new BulletinBoardPost(this.httpService, true, this.tenantTZ, this.interService).deserialize(input.message_board_post);
		}
		if (input.message_board_post_comment) {
			this.message_board_post_comment = new BulletinBoardPostComment(this.tenantTZ, this.interService).deserialize(input.message_board_post);
		}
		if (input.sick_message) {
			this.sick_message = new SickMessage(this.tenantTZ, this.interService).deserialize(input.sick_message);
		}
		if (input.availability) {
			this.availability = new Availability(this.tenantTZ, this.interService).deserialize(input.availability);
		}
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}

		return this;
	}
}
